import routes from '~/apiRouter';

export const updateUserData = async (formData) => {
  const updateUserDataRequests = formData.map(async ({id, inputs}) => {
    if (inputs) {
      const options = {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          SNILS: inputs.snils,
          DIPLOMA_REG_NUMBER: inputs.diplomaRegNumber,
          DIPLOMA_QUALIFICATION: inputs.diplomaQualification,
          DIPLOMA_SERIES: inputs.diplomaSeries,
          DIPLOMA_NUMBER: inputs.diplomaNumber,
        }),
      };
      const token = localStorage.getItem('token');
      if (token) options.headers.Authorization = token;

      const response = await fetch(`${routes.user.edit}${id}`, options);
      const jsonData = await response.json();

      return {...jsonData, id};
    }

    return null;
  });

  return Promise.all(updateUserDataRequests);
};